import { NextPage } from 'next'
import ContactUsScreen from '../screens/ContactUs'
import AppContactUsScreen from '../screens/App-ContactUs'
import { ScreenWidthPort } from '../ScreenWidthContext'

export const ContactUs: NextPage = () => {
    const { showDesktopUI } = ScreenWidthPort()

    return (
        <>
            {showDesktopUI ? (<ContactUsScreen />) : (<AppContactUsScreen />)}
        </>
    )
}

